import { apiURL, axios, bus, i18n } from '../main'
import router from '../router/index.js'
//import store from "./index"

export function b64_to_utf8(str) {
    return decodeURIComponent(escape(window.atob(str)))
}

export const initToken = {
    jwt: '--- void ---',
    validUntil: 1,
    userName: 'user',
    domainID: 0,
    masterDomain: 0
}

export const initUser = {
    ID: 0,
    name: 'user',
    fullname: 'user',
    email: '',
    checkProfile: 0,
}

export const initDomain = {
    ID: 0,
    name: 'domain',
    modules: '',
    active: 1,
    agisID: '',
    creditor: "",
    email: '',
    emailContract: 1,
    language: 'de',
    layout: '',
    trackingids: []
}

export default {
    state: { // state des Moduls wird direkt auf die variable state.modulX gemappt
        token: initToken,
        user: initUser,
        domain: initDomain,
        adresse: {},
        smsSubs: [],
        userBZG: 'xxx'
        //cookiePopup: null
    },
    actions: { // call from outside as action: this.$store.dispatch('LOAD_abcd')
        setJWT: function ({ commit }, jwt) {
            try {
                var payload = JSON.parse(b64_to_utf8(jwt.split('.')[1]))
                sessionStorage.setItem('jwt', jwt)
            } catch (e) {
                //console.log(e)
            }
            commit('setJWT', jwt)
            axios.defaults.headers.common['Authorization'] = jwt

            commit('setUserName', payload.userName)
            commit('setDomainID', payload.domainid)
            commit('setMasterDomain', payload.masterDomain)
            //bus.$emit('success', 'Login erfolgreich, hallo ' + payload.userName+'!')
        },
        logout: async function ({ commit }) {
            // store mutationen sind immer synchron
            commit('setToken', initToken)
            commit('setUser', initUser)
            commit('setDomain', initDomain)
            commit('setAdresse', '')
        },
        loadProfile: async function ({ dispatch, commit }) {
            try {
                let profile = await axios.get(apiURL + 'userManager.cfc?method=getProfil')
                commit('setUser', profile.data.user)
                commit('setDomain', profile.data.domain)
                bus.$emit('setGoogleanalyticsID', profile.data.domain.trackingids)
                commit('setAdresse', profile.data.adresse)
                commit('setUserBZG', profile.data.userBZG)
                commit('setBetriebe', profile.data.betriebe)
                await dispatch('setBetriebSelected', 0, { root: true })
                await dispatch('setTierarten', profile.data.tierarten)
                //bus.$emit('profileLoaded', 'Loaded profile')
            }
            catch (e) {
                bus.$emit('error', 'Error loading profil ... ' + JSON.stringify(e.message))
                commit('setToken', initToken)
                commit('setUser', initUser)
                commit('setDomain', initDomain)
                commit('setAdresse', {})
                commit('setUserBZG', '')
            }
        },
        loadSMSSubs: async function ({ commit }) {
            try {
                let smsSubs = await axios.get(apiURL + 'userManager.cfc?method=getSMSSubs')
                commit('setSMSSubs', smsSubs.data)
            }
            catch (e) {
                bus.$emit('error', 'Error loading SMS Pin codes ... ' + JSON.stringify(e.message))
                commit('setSMSSubs', [])
            }
        },
        stopSMS: async function ({ commit, dispatch }, smssubID) {
            try {
                let stop = await axios.get(apiURL + 'userManager.cfc?method=stopSMS', { params: { ID: smssubID } })
                bus.$emit('message', stop.data)
                await dispatch("loadSMSSubs")
            }
            catch (e) {
                bus.$emit('error', 'Error loading SMS Pin codes ... ' + JSON.stringify(e.message))
                commit('setSMSSubs', [])
            }
        },
        setEmailVersandVertrag: async function ({ commit }, emailVertrag) {
            try {
                const formData = new FormData()
                formData.append('emailVertrag', emailVertrag)
                await axios.post(apiURL + 'userManager.cfc?method=setEmailVertrag', formData)
                commit('setEmailContract', emailVertrag)
            }
            catch (e) {
                bus.$emit('error', 'Error saving emailVertrag ... ' + JSON.stringify(e.message))
            }
        },
        saveEmail: async function ({ state }, email) {
            try {
                const formData = new FormData()
                formData.append('email', email.email.trim())
                formData.append('language', email.language)
                await axios.post(apiURL + 'userManager.cfc?method=setEmail', formData)
                state.domain.email = email.email.trim()
                state.domain.language = email.language
                if (state.user.checkProfile === 99) {
                    state.user.checkProfile = 0
                    state.token.masterDomain = 1
                    router.push("/" + i18n.locale + "/home")
                }
                if (state.user.checkProfile === 1) {
                    state.user.checkProfile = 0
                    router.push("/" + i18n.locale + "/home")
                }
                //bus.$emit('success', i18n.t('DankMitteilung'))
            }
            catch (e) {
                bus.$emit('error', 'Error saving email ... ' + JSON.stringify(e.message))
            }
        },
    },
    mutations: { //call with this.$store.commit('setExampleFn',{'a':'b'})
        setJWT: function (state, jwt) {
            state.token.jwt = jwt
        },
        setUserName: function (state, userName) {
            state.token.userName = userName
        },
        setDomainID: function (state, domainID) {
            state.token.domainID = domainID
        },
        setMasterDomain: function (state, masterDomain) {
            state.token.masterDomain = masterDomain
        },
        setToken: function (state, token) {
            state.token = token
        },
        setUser: function (state, user) {
            state.user = user
        },
        setDomain: function (state, domain) {
            state.domain = domain
        },
        setDomainActive: function (state, active) {
            state.domain.active = active
        },
        setEmailContract: function (state, value) {
            state.domain.emailContract = value
        },
        setDomainKreditor: function (state, obj) {
            state.domain.creditor = obj.kreditor
        },
        setSMSSubs: function (state, smsSubs) {
            state.smsSubs = smsSubs
        },
        setAdresse: function (state, adresse) {
            state.adresse = adresse
        },
        setUserBZG: function (state, userBZG) {
            state.userBZG = userBZG
        },
    }
}